"use client";

import { useState } from "react";
import { Button } from "@/components/atoms/Button/button";
import { usePropertySearchStore } from "@/stores/usePropertySearchStore";

export const ButtonGroup = ({ translations }: { translations: Record<string, any> }) => {
  const OPTIONS = [
    { id: "rent", name: translations.rentHome },
    { id: "sell", name: translations.buyHome },
  ];
  const [active, setActive] = useState(OPTIONS[0]);
  const { setFilter } = usePropertySearchStore();

  const handleClick = (option: typeof OPTIONS[number]) => {
    setActive(option);
    setFilter("minPrice", null);
    setFilter("maxPrice", null);
    setFilter("keyword", option);
  };

  return (
    <div className="mb-5 flex space-x-4">
      {OPTIONS.map((option) => (
        <Button
          key={option.id}
          className="buttonGroup"
          size="sm"
          variant={active.id === option.id ? "destructive" : "default"}
          onClick={() => handleClick(option)}
        >
          {option.name}
        </Button>
      ))}
    </div>
  );
};
